module.exports = __webpack_public_path__ + "img/Sam.21e95182.jpg";